// @ts-nocheck
import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'

const UsersListFilter = ({
  page,
  setPage,
  sDate,
  eDate,
  setSDate,
  setEDate,
  status,
  setStatus,
  category,
  setCategory,
}) => {
  const {updateState} = useQueryRequest()
  const [startDate, setStartDate] = useState(sDate)

  const [endDate, setEndDate] = useState(eDate)

  const [tCategory, setTCategory] = useState(category)
  const [tStatus, setTStatus] = useState(status)

  // @ts-ignore
  const {isLoading} = useQueryResponse()
  const [role, setRole] = useState<string | undefined>()
  const [lastLogin, setLastLogin] = useState<string | undefined>()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const resetData = () => {
    updateState({filter: undefined, ...initialQueryState})
    setSDate(startDate)
    setEDate(endDate)
    setPage(1)
    setTCategory(tCategory)
    setStatus(tStatus)
    setCategory(tCategory)
  }

  const filterData = () => {
    setSDate('')
    setEDate('')
    setPage(1)
    setStartDate('')
    setEndDate('')
    setTCategory('')
    setTStatus('')
    setStatus('')
    setCategory('')
  }

  return (
    <>
      {/* begin::Filter Button */}
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>
      {/* end::Filter Button */}
      {/* begin::SubMenu */}
      <div
        className='menu menu-sub menu-sub-dropdown w-300px w-md-325px position-absolute shadow'
        data-kt-menu='true'
      >
        {/* begin::Header */}
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        {/* end::Header */}

        {/* begin::Separator */}
        <div className='separator border-gray-200'></div>
        {/* end::Separator */}

        {/* begin::Content */}
        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          {/* begin::Input group */}

          {/* end::Input group */}

          {/* begin::Input group */}

          {/* end::Input group */}

          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Start date:</label>
            <input
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={startDate}
              max={new Date().toISOString().split('T')[0]}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>End date:</label>
            <input
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={endDate}
              max={new Date().toISOString().split('T')[0]}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>

          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Category:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              value={tCategory}
              onChange={(e) => setTCategory(e.target.value)}
            >
              <option value=''></option>
              <option value='spam'>Spam</option>
              <option value='abuse'>Abuse</option>
              <option value='inappropriate-content'>Inappropriate content</option>
              <option value='other'>other</option>
            </select>
          </div>

          <div className='mb-10'>
            <label className='form-label fs-6 fw-bold'>Status:</label>
            <select
              className='form-select form-select-solid fw-bolder'
              type='date'
              value={tStatus}
              onChange={(e) => setTStatus(e.target.value)}
            >
              <option value=''></option>
              <option value='pending'>Pending</option>
              <option value='resolved'>Resolved</option>
            </select>
          </div>

          {/* begin::Actions */}
          <div className='d-flex justify-content-end'>
            <button
              type='button'
              disabled={isLoading}
              onClick={filterData}
              className='btn btn-light btn-active-light-primary fw-bold me-2 px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>
            <button
              disabled={isLoading}
              type='button'
              onClick={resetData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
          </div>
          {/* end::Actions */}
        </div>
        {/* end::Content */}
      </div>
      {/* end::SubMenu */}
    </>
  )
}

export {UsersListFilter}
